import type { ComponentProps } from "react";
import { MasonryFlowNodeRenderer } from "@leagueplatform/masonry-renderers";

type MasonryFlowNodeRendererProps = ComponentProps<
  typeof MasonryFlowNodeRenderer
>;

/**
 * Override the BE-supplied Back button so it renders as an outlined pill on
 * every Feature Highlight step. The BE config sets `priority: "tertiary"` on
 * `leadingButton`, which Genesis renders as text-only. Figma requires the
 * outlined `secondary` treatment — this ensures the Back button visual
 * matches the design across all steps, including the final "You're all set!"
 * / "Complete HRA" screens (QUEST-2329).
 *
 * `trailingButton` / `lastStepTrailingButton` keep their BE priority
 * (`primary`) so the "Next" / "Start" / "Complete HRA" CTA stays filled green.
 */
export const MasonryFeatureHighlightFlowRenderer = (
  props: MasonryFlowNodeRendererProps
) => {
  const { navigator } = props;
  const overriddenNavigator = navigator?.leadingButton
    ? {
        ...navigator,
        leadingButton: {
          ...navigator.leadingButton,
          priority: "secondary" as const,
        },
      }
    : navigator;

  return <MasonryFlowNodeRenderer {...props} navigator={overriddenNavigator} />;
};
